import React from 'react'
import { PayTypeEnum } from 'types/enum'
import classnames from "classnames"

import style from "./index.module.scss"
import { payData } from './index'
import tipImg from "assets/img/png/icon_tip.png"

interface PayListProps {
    payDatas: payData[]
    onSelectPay: (pay: PayTypeEnum, e?: any) => any
    curPay: PayTypeEnum | null
    canAlipaySub?: boolean
    couponPrice?: any
  }
  
const PayList: React.FC<PayListProps> = ({ payDatas, onSelectPay, curPay, canAlipaySub = false ,couponPrice}) => { 
  return (
    <div className={style["pay-list"]}>
      {payDatas.map((pay) => (
        <div
          className={classnames(style["pay-item"], {
            [style.active]: pay.type === curPay,
          })}
          key={pay.type}
          onClick={(e) => onSelectPay(pay.type, e)}
        >
          <img src={pay.icon} alt="" />
          {
            pay.describe
              ? (
                <div className={style['pay-item-card']}>
                  {pay.describe}
                </div>
              )
              : (pay.type === PayTypeEnum.alipay_wap && canAlipaySub&&!couponPrice.discount) 
                ? (
                  <div className={style['alipay-sub']}>
                    {/* <Icon icon="iconicon_tip" /> */}
                    <img src={tipImg} alt="tip"/>
                    <span>到期后自动续费，可随时取消</span>
                  </div>
                )
                : null
          }
        </div>
      ))}
    </div>
  )
}

export default React.memo(PayList)
